export default __webpack_public_path__ + "static/media/GD.7391bfd0.svg";